(function () {
  function hideChrome() {
    var host = document.getElementById("ads-agent-host");
    if (host) host.style.setProperty("display", "none", "important");
    var nodes = document.querySelectorAll("button, a, [role='button']");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var t = ((el.getAttribute("aria-label") || "") + " " + (el.textContent || "")).toLowerCase();
      if (t.indexOf("shop with ai") !== -1 || t.indexOf("explore this product") !== -1) {
        el.style.setProperty("display", "none", "important");
        if (el.parentElement) el.parentElement.style.setProperty("display", "none", "important");
      }
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", hideChrome);
  else hideChrome();

  if (window.MutationObserver && document.body) {
    new MutationObserver(hideChrome).observe(document.body, { childList: true, subtree: true });
  }
})();
